// 版本固定的 CDN 檔案加上子資源完整性（SRI）檢查，CDN 內容遭竄改時瀏覽器會拒絕執行（2026 資安健診）。
// 雜湊值以實際下載的檔案計算；jQuery 的值與 code.jquery.com 官方公布值一致。
// Highcharts 12.6.2（< 9.0.0 有 XSS 弱點 CVE-2021-29489，2026 資安健診 PT-04）：jsdelivr 檔案與 npm 套件
// 逐位元組相同，SHA-256 與 jsdelivr 公布值（data.jsdelivr.com）一致。
const HIGHCHARTS_SRC =
  "https://cdn.jsdelivr.net/npm/highcharts@12.6.2/highcharts.js";
const HIGHCHARTS_INTEGRITY =
  "sha384-/HGbdmoSlRtfmBzDcqYxyT86040gFFFalhmj92Fry1SKkiqwdovRrxxfj4Fb1isO";
const JQUERY_SRC = "https://code.jquery.com/jquery-3.6.0.min.js";
const JQUERY_INTEGRITY =
  "sha384-vtXRMe3mGCbOeY7l30aIg8H9p3GdeSe4IFlP6G8JMa7o7lXvnz3GFKzPxzJdPfGK";

window.HighchartsInit = window.HighchartsInit || {
  promise: null,
  instance: null,
  load: function () {
    if (this.promise) {
      return this.promise;
    }

    if (window.Highcharts) {
      this.instance = window.Highcharts;
      return Promise.resolve(this.instance);
    }

    this.promise = new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = HIGHCHARTS_SRC;
      // SRI 需以 CORS 模式取得資源，否則瀏覽器會直接拒絕執行
      script.integrity = HIGHCHARTS_INTEGRITY;
      script.crossOrigin = "anonymous";

      script.onload = () => {
        this.instance = window.Highcharts;
        resolve(this.instance);
      };

      script.onerror = () => {
        this.promise = null;
        reject(new Error("Failed to load Highcharts"));
      };

      document.head.appendChild(script);
    });

    return this.promise;
  },
};

// 使用共享的 Highcharts 實例
let Highcharts = window.HighchartsInit.instance;

const initHighchartsLoad = () => {
  return window.HighchartsInit.load().then((instance) => {
    Highcharts = instance;
    return instance;
  });
};
initHighchartsLoad();

var jQueryScript = document.createElement("script");
jQueryScript.src = JQUERY_SRC;
jQueryScript.integrity = JQUERY_INTEGRITY;
jQueryScript.crossOrigin = "anonymous";
document.head.appendChild(jQueryScript);
let jQuery = window.jQuery;

// 基金名稱等 API 資料會拼進 HTML 字串後以 jQuery().html() 輸出，先跳脫 HTML 特殊字元
const HTML_ESCAPES = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
};
const escapeHtml = (value) =>
  String(value).replace(/[&<>"']/g, (ch) => HTML_ESCAPES[ch]);

// 會放進 onclick 內 JS 字串（外層又是 HTML 屬性）的網址片段：encodeURIComponent 後只剩英數與
// -_.!~*'()%，再把唯一可能破壞單引號字串的 ' 轉成 %27，兩層語境都不會被跳出
const urlPart = (value) =>
  encodeURIComponent(String(value)).replace(/'/g, "%27");

// actionField 由 WordPress 編輯者設定，可能刻意夾帶額外參數（例如 home&utm_source=wp），
// 因此改用 encodeURI 保留 & = + # 等網址語意；它會編碼 " < > \ 與換行，再把 ' 轉 %27。
// & 另外轉成 &amp;：onclick 屬性會先做 HTML 實體解碼，否則 &#39; 之類的實體會被還原成引號，
// 解碼後仍是 &，網址語意不變
// 已經是 %XX 的百分比編碼保留原樣（encodeURI 會把 % 編成 %25，造成重複編碼）
const urlQueryValue = (value) =>
  encodeURI(String(value))
    .replace(/%25([0-9A-Fa-f]{2})/g, "%$1")
    .replace(/'/g, "%27")
    .replace(/&/g, "&amp;");

// 傳參數的方式
// let scriptId = document.getElementById("fundScript").attributes['data-url']
// let url = scriptId.value

// // actionField
// let actionField = document.getElementById("fundScript").attributes['action-field'].value

// // 動態 ID
// let fundId = document.getElementById("fundScript").attributes['fund-id'] && document.getElementById("fundScript").attributes['fund-id'].value || 'fundTable'

// // show button or not
// let getValue = document.getElementById("fundScript").attributes['is-show-button'] && document.getElementById("fundScript").attributes['is-show-button'].value === 'false' ? false : true
// let isShowButton = document.getElementById("fundScript").attributes['is-show-button'] ? getValue : true;

// // size
// let pageSize = document.getElementById("fundScript").attributes['page-size'] && document.getElementById("fundScript").attributes['page-size'].value || 5

// let filterCondition = url.split('?')[1] + `&size=${pageSize}`
// let fundInfo = []

jQueryScript.onload = function () {
  // 頁面若未預先載入 jQuery，外掛載入當下取得的是 undefined，需等 CDN 載入完成後再取用
  if (!jQuery) jQuery = window.jQuery;
  let scriptElement = document.querySelectorAll("script[data-url]");
  scriptElement.forEach((item) => {
    let url = "";
    let actionField = "";
    let fundId = "";
    let isShowButton = true;
    let pageSize = "";
    let filterCondition = "";

    let scriptId = item.attributes["data-url"];
    url = scriptId.value;

    // actionField
    actionField = item.attributes["action-field"].value;

    // 動態 ID
    fundId =
      (item.attributes["fund-id"] && item.attributes["fund-id"].value) ||
      "fundTable";

    // show button or not
    let getValue =
      item.attributes["is-show-button"] &&
      item.attributes["is-show-button"].value === "false"
        ? false
        : true;
    isShowButton = item.attributes["is-show-button"] ? getValue : true;

    // 基金外開路徑
    let fundUrl =
      (item.attributes["fund-url"] && item.attributes["fund-url"].value) ||
      false;

    // size
    pageSize =
      (item.attributes["page-size"] && item.attributes["page-size"].value) || 5;

    filterCondition = url.split("?")[1] + `&size=${pageSize}`;

    loadScript();

    function NumFormatter(num, decimal) {
      // 報酬率應為數值；若 API 回傳字串，toLocaleString 會原樣傳回，因此先跳脫再拼進 HTML
      this.value =
        num !== null && num !== undefined
          ? escapeHtml(
              num.toLocaleString(undefined, {
                minimumFractionDigits: decimal,
                maximumFractionDigits: decimal,
              })
            )
          : "--";

      this.addPercent = function () {
        this.value =
          num !== null && num !== undefined ? `${this.value}%` : this.value;
        return this;
      };

      this.addPrefix = function () {
        if (num > 0) this.value = `+${this.value}`;
        if (num < 0) this.value = `${this.value}`;
        return this;
      };
    }

    function numHandler(num, decimal = 2) {
      return new NumFormatter(num, decimal);
      // example: numHandler(12345.5432).addPercent().addPrefix().value   should return +12,345.54%
    }

    function numTextColor(num) {
      if (num !== null && num !== undefined) {
        return num > 0
          ? "text-red-500"
          : num < 0
          ? "text-green-500"
          : "text-gray-500";
      } else {
        return "text-gray-800";
      }
    }

    // Highcharts 实例化函数
    function createHighcharts(chartData, minY) {
      // 颜色配置
      let color = {
        red: {
          line: "#FA3130",
          gradient: [
            [0, "rgba(250, 49, 48, 0.7)"],
            [1, "rgba(250, 49, 48, 0)"],
          ],
        },
        green: {
          line: "#2BAB52",
          gradient: [
            [0, "rgba(43, 171, 82, 0.7)"],
            [1, "rgba(43, 171, 82, 0)"],
          ],
        },
        gray: {
          line: "#CCCCCC",
          gradient: [
            [0, "rgba(204, 204, 204, 0.7)"],
            [1, "rgba(204, 204, 204, 0)"],
          ],
        },
      };

      // 计算颜色
      let start = chartData[0];
      let end = chartData[chartData.length - 1];
      let trend = end - start;
      let chartColor =
        trend > 0 ? color["red"] : trend < 0 ? color["green"] : color["gray"];

      // 返回 chartOptions 对象
      return {
        chart: {
          type: "areaspline",
          margin: [0, 0, 0, 0],
          backgroundColor: "rgba(0, 0, 0, 0)",
        },
        title: {
          text: null,
        },
        legend: {
          enabled: false,
        },
        plotOptions: {
          areaspline: {
            marker: {
              enabled: false,
            },
          },
        },
        xAxis: {
          visible: false,
        },
        yAxis: {
          visible: false,
          min: minY,
        },
        credits: {
          enabled: false,
        },
        // Highcharts 10 起未載入無障礙模組時，每張圖都會在 console 印出警告；本來就未載入，關閉提示
        accessibility: {
          enabled: false,
        },
        series: [
          {
            data: chartData,
            lineColor: chartColor.line,
            fillColor: {
              linearGradient: {
                x1: 0,
                x2: 0,
                y1: 0,
                y2: 1,
              },
              stops: [chartColor.gradient[0], chartColor.gradient[1]],
            },
            lineWidth: 1.5,
            enableMouseTracking: false,
          },
        ],
      };
    }

    // 使用 createHighcharts 函數创建 Highcharts 实例
    function createChart(chartContainer, chartData) {
      let min = Math.min(...chartData);
      const charsData = createHighcharts(chartData, min);
      if (chartContainer) {
        Highcharts && Highcharts.chart(chartContainer, charsData);
      }
    }

    function getCurrentDate() {
      const now = new Date();
      const latestDate = `${now.getFullYear()}/${String(
        now.getMonth() + 1
      ).padStart(2, "0")}/${String(now.getDate()).padStart(2, "0")}`;
      const allUpdateDateElements = document.querySelectorAll(
        ".fund-list-latest-date"
      );
      allUpdateDateElements.forEach((element) => {
        element.textContent = `${latestDate} 更新`;
      });
    }

    let table = "";
    const mql = window.matchMedia("(min-width: 1024px)");
    mql.addListener(handleTableDisplay);
    let fundInfo = [];

    function handleTableDisplay(e) {
      if (e.matches) {
        // 建立 table，header 是 基金名稱、近 3 月走勢、 3 個月、 6 個月、 1 年、 3 年、5 年、成立至今、操作
        table = `
                <div style="overflow-x: auto; width: 100%;">
                <table class="fundTableStyle" style="background-color: white;">
                    <div class="fund-list-reward-title" style="color: #333333; font-weight: 500; font-size: 18px; line-height: 1.75rem; position: sticky; left: 0;">
                        基金報酬
                        <span class="fund-list-latest-date" style="font-size: 14px; color: #999999"></span>
                    </div>
                    <thead>
                        <tr style="border-bottom: 1px solid #E5E5E5">
                        <th style="text-align: left; position: sticky; background-color: white; left:0">
                            基金名稱
                        </th>
                        <th>近 3 月趨勢</th>
                        <th>3 個月</th>
                        <th>6 個月</th>
                        <th>1 年</th>
                        <th>2 年</th>
                        <th>3 年</th>
                        <th>5 年</th>
                        <th>成立至今</th>
                        <th class="btnShow" style="position: sticky; background-color: white; right:0;" ></th>
                        </tr>
                    </thead>
                    <tbody>
                    `;
        // 將基金資料放入 table
        fundInfo.forEach((item) => {
          // fundUrl 為 true，將基金名稱改為 /fundinfo-${mfxId}/
          let path =
            fundUrl == true || fundUrl == "true"
              ? `fundinfo-${urlPart(item.mfxId)}`
              : `trade/funds/${urlPart(item.mfxId)}`;
          table += `
                        <tr style="border-bottom: 1px solid #E5E5E5;">
                            <td style="position: sticky; background-color: white; left:0; z-index: 10">
                                <a class="fs-fundlist-name" href="#" onclick="window.open('https://${
                                  window.location.host
                                }/${path}/?actionField=${urlQueryValue(
            actionField
          )}', '_self'); return false;">
                                    ${escapeHtml(item.fundShortName)}${
            item.warningWarning !== null
              ? `<span style="font-weight: 700;">(${escapeHtml(
                  item.warningWarning
                )})</span>`
              : ""
          }
                                </a>
                            </td>
                            <td><div id="${escapeHtml(
                              item.mfxId
                            )}" style="width: 96px; height: 48px;"></div></td>
                            <td class="${numTextColor(
                              item.rateOfReturn3Months
                            )} text-sm">${
            numHandler(item.rateOfReturn3Months).addPercent().addPrefix().value
          }</td>
                            <td class="${numTextColor(
                              item.rateOfReturn6Months
                            )} text-sm">${
            numHandler(item.rateOfReturn6Months).addPercent().addPrefix().value
          }</td>
                            <td class="${numTextColor(
                              item.rateOfReturn1Year
                            )} text-sm">${
            numHandler(item.rateOfReturn1Year).addPercent().addPrefix().value
          }</td>
                            <td class="${numTextColor(
                              item.rateOfReturn2Year
                            )} text-sm">${
            numHandler(item.rateOfReturn2Year).addPercent().addPrefix().value
          }</td>
                            <td class="${numTextColor(
                              item.rateOfReturn3Years
                            )} text-sm">${
            numHandler(item.rateOfReturn3Years).addPercent().addPrefix().value
          }</td>
                            <td class="${numTextColor(
                              item.rateOfReturn5Years
                            )} text-sm">${
            numHandler(item.rateOfReturn5Years).addPercent().addPrefix().value
          }</td>
                            <td class="${numTextColor(
                              item.rateOfReturnSinceEstablishment
                            )} text-sm">
                            ${
                              numHandler(item.rateOfReturnSinceEstablishment)
                                .addPercent()
                                .addPrefix().value
                            }
                            ${
                              item.establishmentDate !== null
                                ? `<div style="font-size: 12px; color: #999; white-space: nowrap;">從 ${escapeHtml(
                                    item.establishmentDate
                                  ).replaceAll("-", "/")}</div>`
                                : ""
                            }
                            </td>
                            <td class="btnShow" style="position: sticky; background-color: white; right:0;">
                                <a href="#" onclick="window.open('https://${
                                  window.location.host
                                }/${path}/?actionField=${urlQueryValue(
            actionField
          )}', '_self'); return false;">
                                    <div class="fundBtnStyle" style="white-space: nowrap;">
                                        <span> 申購 <span style="color: #FFFF00">0</span> 手續費 </span>
                                    </div>
                                </a>
                            </td>
                        </tr>
                        `;
        });

        table += `
                    </tbody>
                </table>
            </div>
            `;
      } else {
        table = `
                <div style="color: #333333; font-weight: 500; font-size: 18px; line-height: 1.75rem; margin-bottom: 0.75rem; position: sticky; left: 0;">
                    基金報酬
                    <span class="fund-list-latest-date" style="font-size: 14px; color: #999999"></span>
                </div>`;

        // 視窗寬度小於 1024px
        fundInfo.forEach((item) => {
          // fundUrl 為 true，將基金名稱改為 /fundinfo-${mfxId}/
          let path =
            fundUrl == true || fundUrl == "true"
              ? `fundinfo-${urlPart(item.mfxId)}`
              : `trade/funds/${urlPart(item.mfxId)}`;
          table += `
                <div style="background-color: white;">
                <div> 
                    <a class="fs-fundlist-name" href="#" onclick="window.open('https://${
                      window.location.host
                    }/${path}/?actionField=${urlQueryValue(
            actionField
          )}', '_self'); return false;">
                        ${escapeHtml(item.fundShortName)}${
            item.warningWarning !== null
              ? `<span style="font-weight: 700;">(${escapeHtml(
                  item.warningWarning
                )})</span>`
              : ""
          } 
                    </a>
                <div class="fundScroll" style="background-color: #F5F5F5; overflow-x: auto; display: flex; gap: 20px; white-space: nowrap;
                padding: 8px 16px; font-size: 14px;
                color: #666; margin-top: 8px; border-radius: 4px;">
                    <div>
                        <div>近 3 月趨勢</div>
                        <div id="${escapeHtml(
                          item.mfxId
                        )}" style="width: 80px; height: 24px;"></div>
                    </div>
                    <div>
                        <div>3 個月</div>
                        <div style="width: 60px" class="${numTextColor(
                          item.rateOfReturn3Months
                        )} text-sm">${
            numHandler(item.rateOfReturn3Months).addPercent().addPrefix().value
          }</div>
                    </div>
                    <div>
                        <div>6 個月</div>
                        <div style="width: 60px" class="${numTextColor(
                          item.rateOfReturn6Months
                        )} text-sm">${
            numHandler(item.rateOfReturn6Months).addPercent().addPrefix().value
          }</div>
                    </div>
                    <div>
                        <div>1 年</div>
                        <div style="width: 60px" class="${numTextColor(
                          item.rateOfReturn1Year
                        )} text-sm">${
            numHandler(item.rateOfReturn1Year).addPercent().addPrefix().value
          }</div>
                    </div>
                    <div>
                        <div>2 年</div>
                        <div style="width: 60px" class="${numTextColor(
                          item.rateOfReturn2Year
                        )} text-sm">${
            numHandler(item.rateOfReturn2Year).addPercent().addPrefix().value
          }</div>
                    </div>
                    <div>
                        <div>3 年</div>
                        <div style="width: 60px" class="${numTextColor(
                          item.rateOfReturn3Years
                        )} text-sm">${
            numHandler(item.rateOfReturn3Years).addPercent().addPrefix().value
          }</div>
                    </div>
                    <div>
                        <div>5 年</div>
                        <div style="width: 60px" class="${numTextColor(
                          item.rateOfReturn5Years
                        )} text-sm">${
            numHandler(item.rateOfReturn5Years).addPercent().addPrefix().value
          }</div>
                    </div>
                    <div>
                        <div>成立至今</div>
                        <div class="${numTextColor(
                          item.rateOfReturnSinceEstablishment
                        )} text-sm">
                        ${
                          numHandler(item.rateOfReturnSinceEstablishment)
                            .addPercent()
                            .addPrefix().value
                        }
                        ${
                          item.establishmentDate !== null
                            ? `<span style="font-size: 12px; color: #999; white-space: nowrap;">從 ${escapeHtml(
                                item.establishmentDate
                              ).replaceAll("-", "/")}</span>`
                            : ""
                        }
                        </div>
                    </div>
                </div>
                <div style="display: flex;
                justify-content: end;
                margin: 16px 0px;
                border-bottom: 1px solid #EBEBEB;
                padding-bottom: 14px;" >
                    <a class="btnShow" href="#" onclick="window.open('https://${
                      window.location.host
                    }/${path}/?actionField=${urlQueryValue(
            actionField
          )}', '_self'); return false;">
                        <div class="fundBtnStyle" style="white-space: nowrap;">
                            <span> 申購 <span style="color: #FFFF00">0</span> 手續費 </span>
                        </div>
                    </a>
                </div>
                </div>
                `;
        });
      }

      jQuery(`#${fundId}`).html(
        table +
          `<div style="font-size: 14px; margin-top: 16px; background: #f5f5f5; padding: 16px; border-radius: 4px;">資料來源：好好證券彙整，詳見重要聲明。</div>`
      );

      // 控制顯示或隱藏操作按鈕
      const elements = document.querySelectorAll(".btnShow");
      elements.forEach((element) => {
        element.style.display = isShowButton ? "table-cell" : "none";
      });

      // 同步滾動
      const fundInfoBlocks = document.querySelectorAll(".fundScroll");
      fundInfoBlocks.forEach((block) => {
        block.addEventListener("scroll", function () {
          const scrollLeft = this.scrollLeft;
          fundInfoBlocks.forEach((otherBlock) => {
            if (otherBlock !== this) {
              otherBlock.scrollLeft = scrollLeft;
            }
          });
        });
      });

      // 初始化 Highcharts
      setTimeout(() => {
        fundInfo.forEach((item) => {
          createChart(item.mfxId, item.navLast3Months);
        });
      }, 600);
    }

    function loadScript() {
      jQuery("#more").attr("href", url).attr("target", "_blank");

      // 呼叫找基金的 API
      jQuery
        .ajax(
          `https://${window.location.host}/next/api/funds/search?${filterCondition}`
        )
        .done((res) => {
          fundInfo = res.items;

          // 取得 fundInfo 中的 mfxId 並組成字串用,分隔，限制 5 筆
          let mfxId = fundInfo
            .map((item) => urlPart(item.mfxId))
            .slice(0, 5)
            .join(",");

          // 比較基金的網址
          let compareUrl = `https://${window.location.host}/trade/funds-compare/?mfxID=${mfxId}`;
          jQuery("#compareFund")
            .attr("href", compareUrl)
            .attr("target", "_blank");

          // 呼叫 handleTableDisplay 函數，傳遞 fundInfo 進行顯示
          handleTableDisplay(mql);
          setTimeout(() => {
            getCurrentDate();
          }, 600);
        });
    }
  });
};
